export default "__VITE_ASSET__DpDkoiVC__"